<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <template v-slot:activator="{}">
      <div class="bottomActions">
        <button
          class="logoutBtn"
          @click="_showDialog"
        >
          {{labelText}}
        </button>
      </div>
    </template>
    <v-card v-if="isLoaderActive">
      <div class="progressWrapper">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
      </div>
    </v-card>
    <v-card v-if="!isLoaderActive">
      <v-card-title>
        <span class="headline">{{labelText}}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="cols"
            >
              <v-text-field
                v-model="field.email"
                label="Email"
                disabled
              />
            </v-col>

            <v-col
              cols="12"
              class="cols"
            >
              <v-select
                v-model="field.feedbackType"
                :items="feedbackTypes"
                label="Feedback Type *"
                item-text="name"
                item-value="id"
                required
                :error="!field.feedbackType && isFormDirty"
              />
            </v-col>
            <v-col
              cols="12"
              class="cols"
            >
              <v-textarea
                v-model="field.feedbackText"
                name="input-7-1"
                label="Your feedback *"
                hint="Provide your feedback here"
                required
                :error="!field.feedbackText && isFormDirty"
              />
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          text
          @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="submitFeedback"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar"
    >
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from '../../../../api-calls'
  // import HttpConnector from '../../../utils/http-connector'
  // import AuthService from '@/services/AuthService'
  // const auth = new AuthService()

  export default {
    name: 'FeedbackDialog',
    props: {
      labelText: {
        type: String,
        default: 'Help and support'
      }
    },
    data: () => ({
      // httpConnector: new HttpConnector(),
      // apiEndpoint: process.env.VUE_APP_API_BASE_URL,
      // apiCode: process.env.VUE_APP_API_CODE,
      user: null,
      dialog: false,
      isLoaderActive: false,
      feedbackTypes: [{
        name: 'Report a bug',
        id: 'bug',
      }, {
        name: 'Request an enhancement',
        id: 'enhancement',
      }],
      field: {
        email: '',
        feedbackType: '',
        feedbackText: '',
      },
      username: '',
      isFormDirty: false,
      snackbar: false,
      notification: 'Unknown',
    }),

    watch: {
      dialog (val) {
        // eslint-disable-next-line no-unused-expressions
        if (!val) {
          this.close()
          this.reset()
        }
      },
    },

    async created () {
      this.username = localStorage.getItem('username')
      // this.user = await auth.getUser()
      this.field.email = this.username
      this.field.name = this.user.profile.name
      await this.initialize()
    },

    methods: {
      initialize () {},

      _showDialog () {
        this.dialog = true
      },

      close () {
        this.dialog = false
        this.field = {
          name: '',
          email: '',
          feedbackType: '',
          feedbackText: '',
        }
        this.isFormDirty = false
        this.snackbar = false
      },

      isFormValid () {
        let isValid = true
        if (!this.field.feedbackType) {
          isValid = false
        }
        if (!this.field.feedbackText) {
          isValid = false
        }
        return isValid
      },

      reset () {
        this.field = {
        email: '',
        feedbackType: '',
        feedbackText: '',
        }
      },

      async submitFeedback () {
        this.isFormDirty = true
        if (!this.isFormValid()) {
          this.notification = 'Fill all the required fields'
          this.snackbar = true
          return
        }
        this.isLoaderActive = true;

        /** Prepare params for API call * */
        const params = {
          ToEmails: "admin@poscommunication.com",
          FromEmail: this.field.email,
          Subject: this.field.feedbackType,
          Content: this.field.feedbackText
        }

        try {
          await ApiCalls.postFeedback(params);
          // this.$emit('on-success')
          this.notification = 'Posted successfully!'
          this.snackbar = true
            setTimeout(() => {
              this.isLoaderActive = false;
              this.close()
            }, 1500);
            // this.reset()
        } catch (error) {
            console.log('error :>> ', error);
            this.isLoaderActive = false;
            this.notification = 'Unable to post feedback'
            this.snackbar = true
        }
      },
    },
  }
</script>

<style lang="scss">
.cols {
  padding-top: 0px!important;
  padding-bottom: 0px!important;
}
.v-card .v-card__actions {
    margin-top: -35px;
}
.triggerButton {
  width: 100%;
}
</style>

<style lang="sass">
.bottomActions
    margin-top: 25px
    position: absolute
    bottom: 0
    left: 0
    width: 90%
    margin: 15px
    .knowledgeBase
      padding: 25px 20px
      text-decoration: underline
      cursor: pointer
      text-align: center
    .logoutBtn
      border: 1px solid grey
      border-radius: 3px
      background-color: transparent
      width: 100%
      height: 40px
      display: flex
      justify-content: center
      align-items: center
</style>
